export const variants = [
  { size: 40, blurred: false },
  { size: 300, blurred: false },
  { size: 600, blurred: false },
  { size: 40, blurred: true },
  { size: 300, blurred: true },
];

export function imageVariantName(
  fileName: string,
  width: number | string,
  height: number | string = width,
  blurred = false,
): string {
  return `${width}_${height}_${blurred ? "blurred_" : ""}${fileName}`;
}
